export enum ANALYTICS_ERROR_TYPE {
  API = 'api',
  PAGE = 'page',
}

export const ANALYTICS_PAGE_TYPE = {
  'path': 'page_type',
  DEFAULT: 'care|faults|dashboard',
};
